import { Row, Col, Badge } from 'antd';
import './EbInbox.less';
import profile from 'assets/images/home/Profile-filled.svg';
import notification from 'assets/images/home/notifications.svg';
import { useNavigate } from 'react-router-dom';
import { useInboxMessagesContext } from 'contexts/inboxMessages';
const EbInbox = () => {
  const navigate = useNavigate();
  const { unreadMessageCount } = useInboxMessagesContext();

  return (
    <div className="eb-Inbox">
      <Row>
        <Col>
          <img
            src={profile}
            alt=""
            style={{
              marginRight: '20px',
              cursor: 'pointer',
            }}
            onClick={() => navigate('/profile')}
          />
        </Col>
        <Col>
          <Badge dot={unreadMessageCount > 0} color="#E9573D" offset={[-7, 3]}>
            <img
              src={notification}
              alt=""
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/inbox')}
            />
          </Badge>
        </Col>
      </Row>
    </div>
  );
};
export default EbInbox;
